import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessResponse } from 'src/app/personal-info/models/personal-info.model';
import { HttpHandlerService } from 'src/app/shared-resources/services/http-handler.service';
import { UrlMapService } from 'src/app/shared-resources/services/url-map.service';
import { SubscriptionDetails, Youtubelist } from '../models/subscriptions.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {

   /** return selected menu  */
   get selectedMenu(): string {
    return sessionStorage.getItem('subscriptionSelectedMenu') as string;
  }

  constructor(
    private urlMapService: UrlMapService,
    private https: HttpHandlerService,
    private httpClient: HttpClient
  ) { }


   /** update selected subscription menu */
   public updateSelectedMenu(menuName: string): void {
    sessionStorage.setItem('subscriptionSelectedMenu', menuName);
  }

  /** get Languages for agent api method */
  getAuthentisignSubscription(agentNumber: number) {
    const url = this.urlMapService.getAuthentisignSubscriptionUrl() + agentNumber + '/authenti-sign';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

    /** get Languages for agent api method */
    getAuthentisignSubscriptionCharge(systemId: number) {
      const url = this.urlMapService.getAuthentisignSubscriptionChargeUrl() + systemId;
      const opts = { observe: 'response' };
      return this.https.get(url, opts);
    }

    /** API to save authentisign subscription */
    saveAuthentisignSubscription(agentNumber: any, renewal: boolean) {
      const url = this.urlMapService.saveAuthentisignSubscriptionUrl() + 'agentNumber=' + agentNumber +'&autoRenewal='+ renewal ;
      return this.https.post(url);
    }

  /** API to get subscription details */
  subscriptionDetail(agentNumber: any, SSType: any): Observable<SubscriptionDetails | null> {
    const url = this.urlMapService.subscriptionDetail() + agentNumber + '/subscription-details/' + SSType;
    return this.httpClient.get<SubscriptionDetails>(url);
  }

  /** API to save docusign data */
  docusign(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.docusign();
    return this.httpClient.post<AccessResponse>(url, data);
  }

 /** API to save ToolkitCMA subscription */
 saveToolkitSubscription(agentNumber: any, renewal: boolean) {
  const url = this.urlMapService.saveToolkitCMASubscriptionURL() + 'agentNumber=' + agentNumber +'&autoRenewal='+ renewal ;
  return this.https.post(url);
 }
 
  /** API to update auto renew in docusign */
  updateDocuSignAutoRenew(agentNumber: any, value: boolean): Observable<AccessResponse> {
    const url = this.urlMapService.updateDocuSignAutoRenew() + agentNumber + '/docu-sign/renew/' + value;
    return this.httpClient.put<AccessResponse>(url, null);
  }

   /** agent info youtube ist for subscription */
   getYoutubeList(agentNumber: any): Observable<SubscriptionDetails>{
    const url = this.urlMapService.youtubeListUrl() + agentNumber + '/youtube-listing';
    return this.httpClient.get<SubscriptionDetails>(url);
  }

  /** agent info youtube ist for subscription */
  getYoutubeHistoryList(agentNumber: any): Observable<SubscriptionDetails>{
    const url = this.urlMapService.youtubeListUrl() + agentNumber + '/youtube-history?bucketNumber=1&bucketSize=10000&sortOrder=0';
    return this.httpClient.get<SubscriptionDetails>(url);
  }

  /** save youtube listing */
  saveYoutubeList(data: any): Observable<Youtubelist> {
    const url = this.urlMapService.saveYoutubeList();
    return this.httpClient.post<Youtubelist>(url, data);
  }

  /** save youtube auto signup */
  saveYoutubeAutosignup(agentNumber: any): Observable<boolean>{
    const url = this.urlMapService.getAuthentisignSubscriptionUrl() + agentNumber + '/youtube-auto-signup';
    return this.httpClient.post<boolean>(url, '');
  }
}
